export default {
  currOptionTitle: {
    en: 'Your plan',
  },
}
